import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrBefore);

/**
 * Calcula headers para: months, weeks, days, hours
 */
export default function useCalendarHeaders({ viewMode, rangeStart, rangeEnd, cellWidth, timelineWidth }) {
  const headers = { months: [], weeks: [], days: [], hours: [] };
  const start = dayjs(rangeStart);
  const end = dayjs(rangeEnd);

  if (viewMode === 'hourly') {
    headers.days.push({
      date: start.toDate(),
      label: start.format('dddd, DD MMMM YYYY'),
      isToday: start.isSame(dayjs(), 'day'),
      position: 0,
      width: timelineWidth
    });
    for (let hour = 0; hour < 24; hour++) {
      const hourDate = start.hour(hour).minute(0).second(0);
      headers.hours.push({
        hour,
        label: `${hour.toString().padStart(2, '0')}:00`,
        shortLabel: `${hour}h`,
        position: hour * cellWidth,
        width: cellWidth,
        isCurrentHour: dayjs().isSame(hourDate, 'hour'),
        isPastHour: hourDate.isBefore(dayjs()),
        isBusinessHour: hour >= 6 && hour <= 23,
        date: hourDate.toDate()
      });
    }
    return headers;
  }

  // Resto de vistas (día/semana/2sem/mes)
  let current = start.clone();
  let currentMonth = null,
    currentWeek = null;
  let monthStartPos = 0,
    weekStartPos = 0,
    dayIndex = 0;

  while (current.isSameOrBefore(end, 'day')) {
    if (!currentMonth || !current.isSame(currentMonth, 'month')) {
      if (currentMonth) {
        headers.months.push({
          label: currentMonth.format('MMMM YYYY'),
          start: monthStartPos,
          width: (dayIndex - monthStartPos) * cellWidth
        });
      }
      currentMonth = current;
      monthStartPos = dayIndex;
    }

    if (!currentWeek || !current.isSame(currentWeek, 'week')) {
      if (currentWeek) {
        headers.weeks.push({
          label: `Sem ${currentWeek.week()}`,
          start: weekStartPos,
          width: (dayIndex - weekStartPos) * cellWidth
        });
      }
      currentWeek = current;
      weekStartPos = dayIndex;
    }

    headers.days.push({
      date: current.toDate(),
      label: current.format('DD'),
      dayName: current.format('ddd'),
      isToday: current.isSame(dayjs(), 'day'),
      isWeekend: [0, 6].includes(current.day()),
      isFirstOfMonth: current.date() === 1,
      position: dayIndex * cellWidth,
      dayOfWeek: current.day()
    });

    current = current.add(1, 'day');
    dayIndex++;
  }

  if (currentMonth) {
    headers.months.push({
      label: currentMonth.format('MMMM YYYY'),
      start: monthStartPos,
      width: (dayIndex - monthStartPos) * cellWidth
    });
  }
  if (currentWeek) {
    headers.weeks.push({
      label: `Sem ${currentWeek.week()}`,
      start: weekStartPos,
      width: (dayIndex - weekStartPos) * cellWidth
    });
  }

  return headers;
}
